import { withInstall } from '@tav-ui/utils/with-install'
import Button from './src/button.vue'
const TaButton = withInstall(Button)
export { TaButton }
export default TaButton
export * from './src/types'
